'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

function formatSourceId(source) {
	if (source) {
		const sourceNumeric = Number(source);
		if (Number.isInteger(sourceNumeric)) {
			// will filter also NaN and Infinity
			return sourceNumeric;
		}
	}
	return null;
}

export function useJobParams() {
	const params = useSearchParams();
	const [state, setState] = useState({ refId: null, sourceId: null, referrer: null });

	useEffect(() => {
		const referrer = document.referrer.split('https://').join('').split('http://').join('')
			.split('/')[0] || sessionStorage.getItem('referrer') || window?.location?.origin.split('https://').join('').split('http://').join('')
			.split('/')[0];

		const refId = params.get('refId') || sessionStorage.getItem('refId');
		const sourceId = formatSourceId(params.get('sourceId') || sessionStorage.getItem('sourceId'));
		setState({ refId, sourceId, referrer });
	}, []);

	return state;
}
